import App from 'app/app.js';

function AddVerifiedSubjectService(
  ShoppingCartStore,
  JobStore,
  SubjectStore,
  RouterService,
  UserProfileStore,
  BlockService,
  $q
) {
  this.goToProofs = () => {
    return this.selectSubject().then(() => RouterService.goToMyProofs());
  };

  this.selectSubject = () =>
    this._trySelectVerifiedMasterEvent().then(function (verifiedMasterEvent) {
      const activeJob = JobStore.getJob();
      const subject = ShoppingCartStore.getCurrentSubject();
      if (verifiedMasterEvent) {
        SubjectStore.updateSubjectByJob(activeJob, subject);
      } else {
        SubjectStore.addOrUpdateSubjectByJob(activeJob, subject);
      }
      ShoppingCartStore.confirmSubjectAccount();
    });

  this._trySelectVerifiedMasterEvent = function () {
    if (!UserProfileStore.isLoggedIn()) {
      return $q.resolve(null);
    }

    const activeJob = JobStore.getJob();

    let verifiedSubject;

    if (this._hasMasterSubject(activeJob)) {
      verifiedSubject = this._findVerifiedSubjectByMasterSubject(activeJob);

      if (!verifiedSubject) {
        verifiedSubject = this._addVerifiedSubject(activeJob);
      }
    } else {
      verifiedSubject = this._findVerifiedSubjectByShoppingCartSubject();
    }

    if (!verifiedSubject) {
      return $q.resolve(null);
    }

    return SubjectStore.attachMasterEventsToSubject(verifiedSubject, true).then(() => {
      if (!SubjectStore.hasEventsLoaded(verifiedSubject)) {
        SubjectStore.removeSubject(verifiedSubject);
        return $q.resolve(null);
      }
      return this._doSelectVerifiedMasterEvent(verifiedSubject, activeJob);
    });
  };

  this._hasMasterSubject = function (job) {
    const isReorder = job.portraitId && job.accessCode;

    return isReorder && job.masterSubject;
  };

  this._findVerifiedSubjectByMasterSubject = function (job) {
    const masterSubject = job.masterSubject;

    return masterSubject.id && SubjectStore.getVerifiedSubjectByMasterSubjectId(masterSubject.id);
  };

  this._findVerifiedSubjectByShoppingCartSubject = function () {
    const shoppingCartSubject = ShoppingCartStore.getCurrentSubject();

    return SubjectStore.getVerifiedSubjects().find(
      (verifiedSubject) =>
        shoppingCartSubject.subjectFirstName === verifiedSubject.subjectFirstName &&
        shoppingCartSubject.subjectLastName === verifiedSubject.subjectLastName &&
        shoppingCartSubject.subjectGrade === verifiedSubject.currentGrade
    );
  };

  this._addVerifiedSubject = (job) => {
    const verifiedSubject = R.clone(job.masterSubject);

    verifiedSubject.subjectLastName = verifiedSubject.lastName;
    verifiedSubject.subjectFirstName = verifiedSubject.firstName;
    verifiedSubject.masterSubjectId = verifiedSubject.id;
    verifiedSubject.unclaimed = true;
    SubjectStore.setEventLoadingStatus(verifiedSubject, 'pending');

    SubjectStore.addMasterSubject(verifiedSubject);

    return verifiedSubject;
  };

  this._doSelectVerifiedMasterEvent = (verifiedSubject, activeJob) => {
    const verifiedMasterEvent = this._findMasterEvent(verifiedSubject, activeJob);

    if (verifiedMasterEvent) {
      this._selectVerifiedMasterEvent(verifiedSubject, verifiedMasterEvent);
    }

    return verifiedMasterEvent;
  };

  this._findMasterEvent = (verifiedSubject, activeJob) => {
    const verifiedMasterEvents = verifiedSubject.masterEvents || [];

    if (activeJob.portraitId && activeJob.accessCode) {
      return this._findMasterEventByPortraitIdAccessCode(
        verifiedMasterEvents,
        activeJob.portraitId,
        activeJob.accessCode
      );
    } else {
      return this._findMasterEventByJobNumber(verifiedMasterEvents, activeJob.jobNumber);
    }
  };

  this._findMasterEventByPortraitIdAccessCode = function (verifiedMasterEvents, portraitId, accessCode) {
    const portraitIdAccessCode = portraitId.replace('-', '') + accessCode;

    return verifiedMasterEvents.find(
      (masterEvent) => masterEvent.subjectInfo.portraitIdAccessCode === portraitIdAccessCode
    );
  };

  this._findMasterEventByJobNumber = (verifiedMasterEvents, jobNumber) => {
    return verifiedMasterEvents.find((masterEvent) => masterEvent.eventType.jobNumber === jobNumber);
  };

  this._selectVerifiedMasterEvent = function (verifiedSubject, verifiedMasterEvent) {
    verifiedSubject.selectedEvent = verifiedMasterEvent;

    var subject = ShoppingCartStore.getCurrentSubject();
    subject.masterSubjectId = verifiedSubject.masterSubjectId;
    subject.ltMasterSubjectUuid = verifiedSubject.ltMasterSubjectUuid;
  };
}

App.service('AddVerifiedSubjectService', [
  'ShoppingCartStore',
  'JobStore',
  'SubjectStore',
  'RouterService',
  'UserProfileStore',
  'BlockService',
  '$q',
  AddVerifiedSubjectService
]);
